module.exports = __webpack_public_path__ + "static/media/about-us.e012eb58.jpg";